import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function to merge Tailwind CSS classes with proper handling
 * of conflicting classes. Combines clsx for conditional classes
 * and tailwind-merge for deduplication.
 *
 * @example
 * cn('px-4 py-2', 'px-6') // => 'py-2 px-6'
 * cn('text-red-500', isActive && 'text-blue-500')
 * cn({ 'bg-white': isLight, 'bg-black': isDark })
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
